import React, {forwardRef, memo, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
  CloseOutlined,
  CopyOutlined,
  ExportOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
} from "@ant-design/icons";
import "./VideoNotes.scss";
import {
    base64ToBlob,
    createCopyLink,
    generateUUID2, getAudioFilterExt,
    getFileNameExt,
    getImagePathWithTheme,
    imgPathPerfix, isAudioFileElement, isBilibiliUrl,
    isDarkMode, isFileVideoElement, isInDraw,
    isStringNullOrEmpty, isYoutubeUrl
} from "../../../../../src/utils";
import {
    EVENT_DELETE_ELEMENT, EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_FAVIRIATE_CHANGE, EVENT_REFRESH_HIGHLIGHT_LIST, EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS, EVENT_REFRESH_VIDEO_TITLE, EVENT_UPDATE_MEDIA_ELEMENT_SRC,
    EVENT_VIDEO_ON_SLIDER_RIGHT, FROM_DIALOG,
    FROM_HOME_DIALOG, HAS_VIDEO_CAPTURE_TEST, KEY_FILE_DIR, MAX_Z_INDEX
} from "../../../../../src/Const";
import {postMessage, recvMessage, unSubscribe} from "../../../../../src/common/event";
import {Dropdown, Input, type MenuProps, message, Tooltip} from "antd";
import i18n, {t} from "i18next";
import i18next from "i18next";
import {IconChangeSource, IconHomeSearch} from "../../../../../src/Icon";
import {
    dbGetHighlight,
    deleteAllCardFromRefProject,
    editDoc,
    getCardById,
    getCardDoc, renameCardById,
    updateCard, updateChangeSource, updateHighlight, updateTranscript
} from "../../../../../model";
import {ipcInvoke, ipcSend} from "../../../../../src/common/ipc";
import {createLibraryItemMenu} from "../../../../../src/MenuUtils";
import Global from "../../../../../src/global";
import {importTranscriptFromContent} from "../../../../../src/VideoHighlightUtils";

interface VideoHeaderProps {
  onCopy: () => void;
  onExport: () => void;
  onFullScreen: () => void;
  onExitFullScreen:()=>void;
  onClose: () => void;
  onSlider:()=>void;
  onSearch:(szSearchKey:any)=>void;
  onImportHighlight:(file:any,content:any)=>void;
  onImportTranscript:(file:any,content:any)=>void;
  type: "model" | "fullScreen";
  element:any;
  from?:any;
  onSetPin?:(isPin:any)=>void;
  isFullScreen?:any;
  onCapture?:()=>void;
    onUpdateMediaPath?:(szNewFilePath:any)=>void
}


const VideoHeader = forwardRef(
  ({ onCopy, onExport, onFullScreen,onExitFullScreen, onClose, type,onSlider,onSearch ,element,from,onImportHighlight,onSetPin,isFullScreen,onCapture,onUpdateMediaPath,onImportTranscript}: VideoHeaderProps,ref) => {
      useImperativeHandle(ref,()=>({
          getIsPin:getIsPin
      }))
      const [searchKey,setSearchKey] = useState('');
      const [isSearchVisible,setIsSearchVisible] = useState(false);
      const inputSearchRef = useRef(null);
      const [libraryData,setLibraryData] = useState(null);
      const [isPin,setIsPin] = useState(false);

      const [menuItems,setMenuItems] = useState<MenuProps['items']>([]);

      const setLibData = async ()=>{
          let libData = await dbGetHighlight(element.id);
          if (!libData){
              libData = await getCardById(element.customData?.generationData?.id);
          }
          setLibraryData(libData);
      }

      const setMoreMenus = async ()=>{
          const arrayMenus = (createLibraryItemMenu('',false,{type:isAudioFileElement(element)?'audio':'video',link:element.link}))

          if (isFileVideoElement(element)){
              let szFilePath = element.customData?.generationData?.fileName;
              if (!element.customData?.generationData?.isAbsolutePath) {
                  szFilePath = localStorage.getItem(KEY_FILE_DIR)+element.customData?.generationData?.fileName;
              }
              const isExist = await ipcInvoke('is-file-exist',{filePath:szFilePath});
              if (!isExist) {
                  arrayMenus.splice(0,0,{
                      label: t("Change source"),
                      key: 'changeSource',
                      icon: <IconChangeSource/>
                  })
              }
          }

          setMenuItems(arrayMenus);
      }

      useEffect(()=>{
          setSearchKey('');
          setIsSearchVisible(false)

          setMoreMenus();

          // if (element.src){
          //     dbGetHighlight(element.id).then(res=>{
          //         setLibraryData(res);
          //     })
          // }else{
          //     getCardById(element.customData?.generationData?.id)?.then(res=>{
          //         setLibraryData(res);
          //     })
          // }
          setLibData();

      },[element])

      useEffect(()=>{
          if (Global.g_isCtrlPressed){
              setIsPin(true);
          }

          recvMessage(EVENT_REFRESH_VIDEO_TITLE,(msg,data)=>{
              setLibData();
          })

          return ()=>{
              unSubscribe(EVENT_REFRESH_VIDEO_TITLE);
          }
      },[])

      const getIsPin = ()=>{
          return isPin;
      }

      const handleMenuClick = async (e)=>{
          const szAction = e.key;
          const item:any = await getCardById(element.customData?.generationData?.id || element.id);

          if (szAction == 'delete') {
              window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Cancel"),t("Delete"),null,async ()=>{
                  window.closeMessage
                  onClose(true);
                  item.isDeleted = 1;
                  item.deleteTime = Date.now();

                  //也删除highlight中的..
                  const res = await dbGetHighlight(item.id);
                  if (res){
                      res.isDeleted = 1;
                      res.deleteTime = item.deleteTime;
                      await updateHighlight(res);
                  }

                  updateCard(item).then(res=>{
                      postMessage(EVENT_FAVIRIATE_CHANGE);
                      postMessage(EVENT_REFRESH_RECENTS);
                      postMessage(EVENT_REFRESH_LIBRARY_LIST);
                      window.globalRefreshList("",item);
                  });


                  //删除这个card所关联的项目
                  deleteAllCardFromRefProject(item);

                  //删除画布上的.....
                  postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:item.id});
              })
          }else if (szAction == 'rename'){
              window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=>{
                  window.closeCommonInput();
                  item.name = szContent;
                  // setData({...item});
                  renameCardById(item.id,item.name).then(res=>{
                      //不知道啥排序，直接刷新列表。。
                      postMessage(EVENT_REFRESH_LIBRARY_LIST)
                      postMessage(EVENT_REFRESH_HIGHLIGHT_LIST);
                      const libData = {...libraryData};
                      libData.name = szContent;
                      setLibraryData(libData);
                  });
              });
          }else if (szAction == 'exportCardPdf'){
              //card to pdf
              const szHtmlDoc:any = await getCardDoc(item.id);
              editDoc(item.id,szHtmlDoc,item.name).then(res=>{
                  setTimeout(() => {
                      ipcSend('save-pdf-to-system', item.id, item.name)
                  }, 10);
              })
          }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
              //导出文件
              const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
              ipcSend('saveFile', {
                  filters: [{name: "All file", extensions: ['*']}],
                  filePath: szFilePath,
                  fileName: item.name+'.'+getFileNameExt(item.fileName)
              })
          }else if (szAction == 'managerTags'){
              //管理标签
              window.showManageTags([item]);
          }else if (szAction == 'addToProject'){
              //添加到project.
              window.showDialogChooseProject([item]);
          }else if (szAction == 'makeACopy'){
              const szHtml = await getCardDoc(item.id);
              const newItem = {
                  ...item,
                  id:generateUUID2(),
                  name:item.name+"("+t("Copy")+")",
                  doc:szHtml
              }
              updateCard(newItem).then(res=>{
                  postMessage(EVENT_REFRESH_LIBRARY_LIST);
                  message.info(t("Copyed"))
              });
          }else if (szAction == 'viewAllHighlights'){
              window.showPdfPreview(item.name,item.id,item.fileName,true,true)
          }else if (szAction == 'addToProjectChecked'){
              // addToProjectEvent();
          }else if (szAction == 'managerTagsChecked'){
              // managerTagsEvent();
          }else if (szAction == 'deleteChecked'){
              // deleteSelectedEvent();
          }else if (szAction == 'favor'){
              if (item.isFavirated){
                  item.isFavirated = 0;
              }else{
                  item.isFavirated = 1;
              }
              item.favirateTime = Date.now();
              updateCard(item,false).then(res=>{
                  postMessage(EVENT_FAVIRIATE_CHANGE);
                  postMessage(EVENT_REFRESH_LIBRARY_LIST);
              });
          }else if (szAction == 'showInfo'){
              window.showInfo('library',item);
          }else if (szAction == 'versionHistory'){
              window.showDialogCardHistory(item.id);
          }
          else if (szAction == 'copyLink'){
              createCopyLink("library", item.id,item.type,null);
          }else if (szAction == 'select'){
              //选择这一个...
              // if (item.type == 'add' && props.type == 'image'){
              //     //添加图片
              //     setIsShowDialogChooseImage(true);
              //     setTimeout(()=>{
              //         dialogChooseImageRef.current?.onShowDialog();
              //     },150);
              // }else{
              //     if (props.onItemSelectedCallback){
              //         if (item.type == 'card'){
              //             item.doc = await getCardDoc(item.id);
              //         }
              //         props.onItemSelectedCallback(item);
              //     }
              // }
          }else if (szAction == 'exportMarkdown'){
              // onExportSingleMd(item);
          }else if (szAction == 'add'){
              // onAddNewItem();
          }else if (szAction == 'edit'){
              // const doc = await getCardDoc(item.id);
              // Global.g_currentNoteData = {...item, doc};
              // openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
          }else if (szAction == 'showInSystemExporler'){
              ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
          }else if (szAction == "importHighlights"){
              //导入--注记
              window.showDialogImportHighlight((file,content)=>{
                  if (onImportHighlight){
                      onImportHighlight(file,content);
                  }
              });
          }else if (szAction == "exportHighlights"){
              //导出注记
              if (onExport){
                  onExport();
              }
          }else if (szAction == 'copyToClipboard'){
             onCopy();
          }else if (szAction == 'changeSource'){
              let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
              if (isAudioFileElement(element)){
                  filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
              }
              ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
                  if (res){
                      //删除第一个
                      const arrayNewMenus = [...menuItems];
                      if (arrayNewMenus[0].key == 'changeSource'){
                          arrayNewMenus.splice(0,1);
                          setMenuItems(arrayNewMenus);
                      }
                      const szNewFilePath = await updateChangeSource(item.id,res);
                      //重新更新视频地址
                      if (onUpdateMediaPath){
                          onUpdateMediaPath(szNewFilePath)
                      }
                      //搞得麻烦了，一个地方更新，各种地方都要更新....
                      postMessage(EVENT_UPDATE_MEDIA_ELEMENT_SRC,{...item,fileName:szNewFilePath})
                  }
              })
          }else if (szAction == 'importTranscript'){
              //导入--字幕
              window.showDialogImportTranscript((file,content)=>{
                  let arrayResults = importTranscriptFromContent(content);
                  //保存....
                  console.log(arrayResults);
                  if (arrayResults && arrayResults.length > 0) {
                      updateTranscript({id: item.id, data: arrayResults}).then(res => {
                          window.globalRefreshList('refresh_transcript_');
                          window.globalRefreshList('show_transcript_in_dialog_');
                      });
                  }
              })
          }
      }


    return (
      <div className="video-header-wrapper">
          <div className="video-content-head-left" style={{display:'flex',alignItems:'center',overflow:'hidden'}}>
              {
                  !isAudioFileElement(element) &&
                  <>
                      <div  className={'flex-center'}>
                          {!isFullScreen ? (
                              <Tooltip zIndex={MAX_Z_INDEX} arrow={false} title={i18next.t("Full screen")}>
                                  <img className={'img-24 cursor-pointer'} onClick={onFullScreen}
                                       src={getImagePathWithTheme('note_full_screen')}/>
                              </Tooltip>

                          ) : (
                              <Tooltip zIndex={MAX_Z_INDEX} arrow={false} title={i18next.t("Exit full screen")}>
                                  <img className={'img-24 cursor-pointer'} onClick={onExitFullScreen}
                                       src={getImagePathWithTheme('note_exit_full_screen')}/>
                              </Tooltip>
                          )}
                      </div>
                      {
                          (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject") || window.location.href.includes('/card') || window.location.href.includes('/journal')) &&
                          <Tooltip zIndex={MAX_Z_INDEX} arrow={false} title={i18next.t("Add to sidebar")}>
                              <img className={'img-14 cursor-pointer ml-10'}
                                   src={getImagePathWithTheme('dialog_slider_right')}
                                   onClick={(event)=>{
                                       event.stopPropagation();
                                       onSlider();
                                   }}/>
                          </Tooltip>
                      }
                      <span className={'span-single-line ml-16'} style={{
                          color: 'var(--text-color)',
                          marginLeft: '16px'
                      }}>{libraryData?.name}</span>
                  </>
              }
              {
                  isAudioFileElement(element) &&
                  <>
                      {
                          from != FROM_HOME_DIALOG &&
                          <Tooltip zIndex={MAX_Z_INDEX} arrow={false} title={i18next.t("Add to sidebar")}>
                              <img className={'img-14 cursor-pointer'}
                                   src={getImagePathWithTheme('dialog_slider_right')}
                                   onClick={onSlider}/>
                          </Tooltip>
                      }
                      <span className={'span-single-line ml-16'} style={{
                          color: 'var(--text-color)',
                          marginLeft: from == FROM_HOME_DIALOG?'0px':'16px'
                      }}>{libraryData?.name}</span>
                  </>
              }


          </div>
          <div className="video-header-right blank-nothing-for-click" onClick={() => {
              // alert('nothing');
          }}>

              {
                  !isAudioFileElement(element) && HAS_VIDEO_CAPTURE_TEST &&
                  <img className={'img-16 cursor-pointer mr-6'} style={{display: 'block', marginTop: '-1px'}}
                       src={getImagePathWithTheme('video_capture')} onClick={() => {
                      if (onCapture) {
                          onCapture()
                      }
                  }}/>
              }

              {
                  isSearchVisible &&
                  <div className={'input-border flex-row-vertical-center'} style={{
                      width: '100%',
                      marginLeft: '34px',
                      height: '32px',
                      backgroundColor: 'var(--input-background-color)!important',
                      border: 'none'
                  }}>
                      <img className='img-16' src={getImagePathWithTheme("home_search")}/>
                      <input className={'input-none'} ref={inputSearchRef}
                             style={{
                                 background: 'transparent',
                                 outline: 'none',
                                 border: 'none',
                                 flexGrow: '1',
                                 margin: '0 6px'
                             }}
                             placeholder={t("Search highlights")} value={searchKey}
                             onChange={(event) => {
                                 setSearchKey(event.currentTarget.value);
                                 onSearch(event.currentTarget.value.toLowerCase());
                             }}/>
                      <img className='img-20 cursor-pointer'
                           style={{display: isStringNullOrEmpty(searchKey) ? "inherit" : "inherit"}}
                           onClick={() => {
                               setSearchKey('');
                               setIsSearchVisible(false);
                               onSearch('');
                           }}
                           src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
                  </div>

              }
              {
                  // !isSearchVisible &&
                  // <Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={i18next.t("Search")}>
                  //     <img className={'img-24 hovered-gray-radius cursor-pointer ml-6'}
                  //          src={getImagePathWithTheme('highlight_search_icon')}
                  //          onClick={(event) => {
                  //              setIsSearchVisible(true);
                  //              setTimeout(() => {
                  //                  inputSearchRef.current?.focus();
                  //              }, 100)
                  //          }}/>
                  // </Tooltip>
              }


              {/*<Tooltip arrow={false} title={i18next.t("Export")}>*/}
              {/*    <img className={'img-24 cursor-pointer ml-6'} src={getImagePathWithTheme('local_video_export')}*/}
              {/*         onClick={onExport}/>*/}
              {/*</Tooltip>*/}

              {/*<Tooltip arrow={false} title={i18next.t("Copy to clipboard")}>*/}
              {/*    <img className={'img-24 cursor-pointer ml-6'} src={getImagePathWithTheme('local_video_copy')}/>*/}
              {/*</Tooltip>*/}

              {/*<Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={i18next.t("Export")}>*/}
              {/*    <img className={'img-24 hovered-gray-radius cursor-pointer ml-6'}*/}
              {/*         src={getImagePathWithTheme('local_video_export')}*/}
              {/*         onClick={onExport}/>*/}
              {/*</Tooltip>*/}
              {/*<Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={i18next.t("Copy to clipboard")}>*/}
              {/*    <img className={'img-24 hovered-gray-radius cursor-pointer ml-6'}*/}
              {/*         src={getImagePathWithTheme('local_video_copy')}*/}
              {/*         onClick={onCopy}/>*/}
              {/*</Tooltip>*/}
              {/*<Tooltip arrow={false} title={i18next.t("Close")}>*/}
              {/*    <img className={'img-24 cursor-pointer ml-6'} src={getImagePathWithTheme('img_close_again_again')}*/}
              {/*         onClick={onClose}/>*/}
              {/*</Tooltip>*/}

              {
                  // isInDraw() &&
                  <Tooltip overlayClassName='font-size-12' title={isPin ? t("UnpinFloatWindow") : t("PinAsFloatWindow")} zIndex={MAX_Z_INDEX}
                           arrow={false}>
                      <img className='img-23 hovered-gray-radius ml-6 mt-2' onClick={() => {
                          setIsPin(!isPin);
                          if (onSetPin) {
                              onSetPin(!isPin);
                          }
                      }} src={getImagePathWithTheme(isPin ? 'dialog_unpin' : 'dialog_pin')}/>
                  </Tooltip>
              }


              <Tooltip arrow={false} className={'ml-6'} zIndex={MAX_Z_INDEX} title={i18next.t("Info")}>
                  <img className={'img-24 hovered-gray-radius cursor-pointer'}
                       src={getImagePathWithTheme('dialog_right_info')}
                       onClick={() => {
                           if (isYoutubeUrl(element.link) || isBilibiliUrl(element.link)) {
                               // dbGetHighlight(element.id).then(res => {
                               //     if (res) {
                               //         res.fileName = res.url;
                               //         window.showInfo('library', res);
                               //     }
                               // })

                               getCardById(element.customData?.generationData?.id).then(res => {
                                   if (res) {
                                       window.showInfo('library', res);
                                   }
                               })

                           } else {
                               getCardById(element.customData?.generationData?.id).then(res => {
                                   if (res) {
                                       window.showInfo('library', res);
                                   }
                               })
                           }

                       }}/>
              </Tooltip>
              <Dropdown overlayClassName='default-dropdown-style'
                        menu={{items: menuItems, onClick: handleMenuClick}}
                        trigger={['click']}>
                  <img className={'img-12 ml-10 cursor-pointer'} src={getImagePathWithTheme('media_view_v_more')}/>
              </Dropdown>

              <img className='img-24 cursor-pointer ml-10 mt-1' onClick={(event) => {
                  event.stopPropagation();
                  onClose();
              }}
                   src={getImagePathWithTheme('icon_pop_close_light.svg')}/>

          </div>
      </div>
    );
  },
);

export default memo(VideoHeader);
